import React from 'react'

// Intentionally dependency-free (no styled-components / theme / context) so it
// still renders when the crash originates inside a provider or the theme layer.
const RootErrorFallback = () => (
  <div
    role='alert'
    style={{
      minHeight: '60vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: '24px',
      fontFamily: 'Proxima-Nova, Helvetica, Arial, sans-serif',
      color: '#000'
    }}
  >
    <h1 style={{ fontSize: '24px', marginBottom: '12px' }}>
      Something went wrong.
    </h1>
    <p style={{ fontSize: '16px', color: '#636363', marginBottom: '24px' }}>
      We hit an unexpected error loading this page. Please try again.
    </p>
    <button
      type='button'
      onClick={() => window.location.reload()}
      style={{
        padding: '10px 24px',
        borderRadius: '360px',
        background: '#000',
        color: '#fff',
        border: 'none',
        fontSize: '16px',
        letterSpacing: '0.8px',
        textTransform: 'uppercase',
        cursor: 'pointer'
      }}
    >
      Reload
    </button>
  </div>
)

export default RootErrorFallback
